import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reCalculationCostTitle: {
		id: 'servicedesk-sla-settings.common.recalculation-warning-message.re-calculation-cost-title',
		defaultMessage: 'SLA edits may take time to take effect',
		description: 'section message displayed for editing sla configuration',
	},
	reCalculationCostWarningMessageJsm: {
		id: 'servicedesk-sla-settings.common.recalculation-warning-message.re-calculation-cost-warning-message-jsm',
		defaultMessage:
			'There are {issueCount} issues in this service project. Recalculating SLAs for this many issues can take a long time (up to a few days sometimes), during which time SLAs and reports may not be accurate.',
		description:
			'warning message displayed when editing calendar or sla configuration impact reports',
	},
});
